import m from "./../../../dist/es2015/themes/Kpal.js";
export const am5themes_Kpal = m;